// Utility function to export data as a CSV file
export const exportToCsv = (filename, rows, options = {}) => {
  try {
    if (!rows || rows.length === 0) {
      console.error('No data available to export.');
      return;
    }

    // Build dynamic headers based on what data is available
    const headers = ['Name'];

    // Check if we have source data in any row
    const hasSource = rows.some(
      (row) => row.source !== undefined && row.source !== null
    );
    if (hasSource) {
      headers.push('Source');
    }

    headers.push('Residual Risk');

    // Check for assurance status columns
    const hasSecurity = rows.some(
      (row) => row.securityStatus !== undefined && row.securityStatus !== null
    );
    const hasPrivacy = rows.some(
      (row) => row.privacyStatus !== undefined && row.privacyStatus !== null
    );
    const hasBias = rows.some(
      (row) => row.biasStatus !== undefined && row.biasStatus !== null
    );

    if (hasSecurity) {
      headers.push('Security Status');
    }
    if (hasPrivacy) {
      headers.push('Privacy Status');
    }
    if (hasBias) {
      headers.push('Bias Status');
    }

    // Add assessment columns - check if using True tenant columns or standard completion
    if (
      options.showTrueAssessmentStatusColumns &&
      rows.some((row) => row.assessmentStatusByPolicy?.length > 0)
    ) {
      headers.push(
        'Pre-Screening Status',
        'Privacy Status',
        'Safeguard Status'
      );
    } else {
      headers.push('Assessment Completion');
    }

    headers.push('Policy Alignment');

    const csvRows = [headers.join(',')];

    // Create a generator function to handle large dataset
    const generateCsvRows = (data) => {
      const dataGenerator = function* () {
        for (const row of data) {
          const values = [row.name || ''];

          if (hasSource) {
            values.push(row.source || '');
          }

          values.push(row.residualRisk || '');

          if (hasSecurity) {
            values.push(row.securityStatus || 'Unverified');
          }
          if (hasPrivacy) {
            values.push(row.privacyStatus || 'Unverified');
          }
          if (hasBias) {
            values.push(row.biasStatus || 'Unverified');
          }

          // Add assessment data
          if (
            options.showTrueAssessmentStatusColumns &&
            row.assessmentStatusByPolicy?.length > 0
          ) {
            // Export True tenant assessment status columns
            const statuses = row.assessmentStatusByPolicy;
            values.push(
              statuses[0]?.status || 'Not Started',
              statuses[1]?.status || 'Not Started',
              statuses[2]?.status || 'Not Started'
            );
          } else {
            // Export standard assessment completion as percentage
            const completion =
              row.assessmentCompletion !== undefined
                ? row.assessmentCompletion
                : 0;
            values.push(`${Math.round(completion)}%`);
          }

          values.push(row.policyAlignment || '');

          yield values.join(',');
        }
      };
      return dataGenerator();
    };

    // Create a CSV string from the generator
    for (const row of generateCsvRows(rows)) {
      csvRows.push(row);
    }

    const csvContent = csvRows.join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');

    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error('Error exporting CSV:', error);
  }
};
